import React from 'react';

const IGESViewer = ({igesUrl}: { igesUrl: string }) => {
    const encodedUrl = encodeURIComponent(igesUrl);
    const viewerUrl = `https://sharecad.org/cadframe/load?url=${encodedUrl}`;

    return (
        <div style={{width: '80%', height: '80%', margin: 'auto', position: 'relative'}}>
            <iframe
                src={viewerUrl}
                width="100%"
                height="100%"
                style={{border: 'none'}}
                title="IGES Viewer"
                allowFullScreen
            />
            {/*<div style={{*/}
            {/*    position: 'absolute',*/}
            {/*    top: 0,*/}
            {/*    right: 0,*/}
            {/*    width: '100%',  // approximate button area*/}
            {/*    height: '53px',*/}
            {/*    backgroundColor: 'white',*/}
            {/*    zIndex: 99,*/}
            {/*    pointerEvents: 'none' // or 'auto' to block interaction*/}
            {/*}} />*/}
            {/*<div style={{*/}
            {/*    position: 'absolute',*/}
            {/*    bottom: 0,*/}
            {/*    right: 0,*/}
            {/*    width: '100%',  // approximate button area*/}
            {/*    height: '65px',*/}
            {/*    backgroundColor: 'white',*/}
            {/*    zIndex: 99,*/}
            {/*    pointerEvents: 'none' // or 'auto' to block interaction*/}
            {/*}} />*/}
        </div>

    );
};

export default IGESViewer;